import styled from "styled-components";
import { DESKTOP } from "common/constants/breakpoints";

export default styled.ul`
  display: grid;
  grid-template-rows: repeat(3, 1fr);
  grid-template-columns: repeat(2, 50%);
  grid-auto-flow: column;
  gap: 16px;
  margin: 0;
  padding: 0;
  margin-top: 14px;
  list-style: none;

  & > li > a {
    color: #ffffff;
    font-size: 10px;
    text-decoration: none;
    cursor: normal;
  }

  @media screen and (min-width: ${DESKTOP}px) {
    display: flex;
    margin-top: 12px;
    margin-left: 20px;
    gap: 0;

    & > li {
      display: flex;

      & > a {
        font-size: 17px;
        display: flex;
        align-items: center;
      }
    }

    & > div.list-separator {
      width: 0px;
      border: solid #ffffff 1px;
      margin: 0 20px;
    }
  }
`;
